import './service-gal.component.scss'

const serviceGalEl = document.querySelector('.service-gal')
if (serviceGalEl) {
  const subSections = serviceGalEl.querySelectorAll('.service-gal__sub-sect')

  subSections.forEach(sub => {
    const cards = sub.querySelectorAll('.service-gal__card')

    cards.forEach(card => {
      const cardId = card.dataset.imgIndex
      const cardImg = serviceGalEl.querySelector(`.service-imgs__main[data-img-index='${cardId}']`)
  
      card.addEventListener('mouseenter', () => {
        const lastActive = sub.querySelector('.service-imgs__main.active')
        if (lastActive) {
          lastActive.classList.remove('active')
        }
        card.classList.add('active')
        cardImg.classList.add('active')
      })
  
      card.addEventListener('mouseleave', () => {
        card.classList.remove('active')
      })
    })
    
    sub.querySelector('.service-imgs__main').classList.add('active')
  })
}